import { render, staticRenderFns } from "./qwTagList.vue?vue&type=template&id=359cfaec&scoped=true&"
import script from "./qwTagList.vue?vue&type=script&lang=js&"
export * from "./qwTagList.vue?vue&type=script&lang=js&"
import style0 from "./qwTagList.vue?vue&type=style&index=0&id=359cfaec&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359cfaec",
  null
  
)

export default component.exports